export enum InterviewMode {
    Readonly = 'readonly',
    Existing = 'existing',
    New = 'new',
    Reflexive = 'reflexive',
    Repeat = 'repeat',
    Health = 'health',
}
export const InteviewModeMap = new Map(Object.values(InterviewMode).map(x => [x.toString(), x]));